import { render, staticRenderFns } from "./UpdateArticleImage.vue?vue&type=template&id=08bcc6ee&"
import script from "./UpdateArticleImage.vue?vue&type=script&lang=js&"
export * from "./UpdateArticleImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports